import type { DatePickerTriggerProps } from './DatePickerTrigger.types'
import cn from 'classnames'
import { BaseField, ValidationIcon } from '../../fields/base-field/BaseField'
import { Icon } from '../../icon'
import styles from './DatePickerTrigger.module.css'
import { getDatePickerDisplayValue } from './getDatePickerDisplayValue'

export function DatePickerTrigger({
  ref,
  value,
  onClick,
  onBlur,
  onKeyDown,
  className,
  disabled,
  placeholder,
  label,
  helpText,
  isOpen,
  status = 'default',
  feedbackText,
  calendarAriaLabel,
}: DatePickerTriggerProps) {
  const displayValue = getDatePickerDisplayValue({ value, placeholder })

  return (
    <BaseField label={label} helpText={helpText} className={cn(styles.baseFieldItem, className)} status={status} feedbackText={feedbackText} disabled={disabled}>
      <button
        type="button"
        ref={ref}
        disabled={disabled}
        onClick={onClick}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        className={styles.trigger}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
        aria-label={calendarAriaLabel}
      >
        <span className={styles.value}>{displayValue}</span>
        <div className={styles.iconsWrapper}>
          <ValidationIcon status={status} />
          <Icon size={20} glyph="Calendar" aria-hidden />
        </div>
      </button>
    </BaseField>
  )
}
